import { IRecruiterDashboardMetrics } from '../../../../../hooks/useRecruiterDashboardMetrics';
import {
  DROPOUT_BREAKPOINTS,
  METRIC_HIGHER_IS_BETTER,
} from '../../../constants';
import { IDateBounds, IDropoutDetailsData, IModalLabels } from '../../types';
import { getThresholdStatus } from '../getThresholdStatus';

export function buildDropoutModalData(
  metrics: IRecruiterDashboardMetrics | null,
  quarterlyDateBounds: IDateBounds,
  labels: IModalLabels
): IDropoutDetailsData | null {
  if (!metrics) return null;

  const status = getThresholdStatus(
    metrics.quarterlyDropoutRate,
    DROPOUT_BREAKPOINTS,
    {
      low: labels.statusGood,
      mid: labels.statusOk,
      high: labels.statusPoor,
    },
    METRIC_HIGHER_IS_BETTER.dropout
  );

  return {
    periodLabel: labels.thisQuarter,
    periodStart: quarterlyDateBounds.start,
    periodEnd: quarterlyDateBounds.end,
    dropoutRate: metrics.quarterlyDropoutRate,
    dropoutCount: metrics.quarterlyDropoutCount,
    activeAtStart: metrics.quarterlyActiveAtStart,
    statusLabel: status.label,
    statusColor: status.color,
    breakpoints: DROPOUT_BREAKPOINTS,
  };
}
